// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IMessageSchema } from '../message/MessageSchema';

export interface IGetMessagesResponseSchema {
  /** Пользователь ответил на опрос **/
  hasPollAnswers: boolean;
  /** Список сообщений **/
  messages: IMessageSchema[];
  /** Периодичность отправки новых рекомендаций **/
  periodicity: EPeriodicity;
  /** Количество непрочитанных сообщений **/
  unreadMessagesCount: number;
}
export enum EPeriodicity {
  /** Ежедневно **/
  'Daily' = 'daily',
  /** Каждые три дня **/
  'EveryThreeDays' = 'everyThreeDays',
  /** Никогда **/
  'Never' = 'never',
  /** Еженедельно **/
  'Weekly' = 'weekly',
}
